// CONTACT CTA

const frame = document.getElementById('contact-cta-form')
if (frame) {
  const form = frame.querySelector('#contact-cta-frame')
  let formHeight = form?.clientHeight
  if (formHeight && formHeight < 500) {
    formHeight = 500
  }

  const trigger = document.getElementById('contact-cta-trigger')
  const openForm = () => {
    if (frame.classList.contains('open')) {
      frame.classList.remove('open')
      frame.style.minHeight = '0'
      frame.style.height = '0'
      frame.style.opacity = '0'
      frame.style.overflow = 'hidden'
    } else {
      frame.classList.add('open')
      frame.style.minHeight = formHeight + 'px'
      frame.style.height = 'auto'
      frame.style.overflow = 'visible'
      setTimeout(() => {
        frame.style.opacity = '1'
      }, 300)
    }
  }

  if (trigger) {
    trigger.addEventListener('click', openForm)
  }
  // document ready javascript

  window.addEventListener('DOMContentLoaded', () => {
    if (window.location.href.indexOf('#kontaktformular') > -1) {
      openForm()
      // check if .error.help-block is show if it is scroll to it
      if (document.querySelector('.error.help-block')) {
        const error = document.querySelector('.error.help-block')
        const errorPosition = error?.getBoundingClientRect().top
        if (errorPosition) {
          window.scrollTo({
            top: errorPosition,
            behavior: 'smooth',
          })
        }
      }
    }
  })
}

// Visitenkarten Formular

function syncSelects() {
  // Holen Sie sich alle Select-Elemente in der aktuellen Seite
  const selects = document.querySelectorAll(
    'select[data-connected-select="office"]'
  )

  selects.forEach((select) => {
    select.addEventListener('change', (event) => {
      // Holen Sie sich den ausgewählten Wert
      const selectedValue = event.target.value

      // Schleife durch alle anderen Selects und setzen Sie ihren Wert auf den ausgewählten Wert, wenn sie einen anderen Wert haben
      selects.forEach((otherSelect) => {
        // loop through all options and if we find a match, set the selected attribute, otherwise leave it
        otherSelect.querySelectorAll('option').forEach((option) => {
          if (option.value === selectedValue) {
            option.setAttribute('selected', 'selected')
          } else {
            option.removeAttribute('selected')
          }
        })
        otherSelect.value = selectedValue
      })
    })
  })
}

syncSelects()
